import styled from 'styled-components';

import { Row } from 'enable-ui';

export const AvatarContainer = styled(Row)`
  width: 92px;
`;

export const Container = styled(Row)`
  .dropdown-children {
    width: 100% !important;
  }
  .slider {
    z-index: 1;
  }
`;
